import { createSelector } from 'reselect';
import { pathOr, uniq } from 'ramda';
import { OfferingDisconnectSelector } from './offering.disconnect.selectors';
export var AllOfferItemsSelector = createSelector([OfferingDisconnectSelector], function (offeringDisconnect) {
  return pathOr(null, ['data', 'RemoveItems'], offeringDisconnect);
});
export var OfferingsSelector = createSelector([AllOfferItemsSelector], function (offerItems) {
  if (!offerItems) {
    return null;
  }
  return uniq(offerItems.map(function (offerItem) {
    return {
      id: offerItem.OrderedOfferingId,
      offeringName: offerItem.OrderedOfferingName,
      removeItems: offerItems.filter(function (offerItemForFiltering) {
        return offerItemForFiltering.OrderedOfferingId === offerItem.OrderedOfferingId;
      })
    };
  }));
});
export var SelectedCustomerOfferingsCurrency = createSelector([OfferingsSelector], function (offerings) {
  //Currently you cannot have a configuration where the customer has offerings with different currency codes.
  if (!offerings || !offerings.length) {
    return null;
  }
  return pathOr(null, ['0', 'removeItems', '0', 'Details', 'PricingPlan', 'Currency'], offerings);
});
export var IsUnderContractForDisconnectOffers = createSelector([OfferingDisconnectSelector], function (offeringDisconnect) {
  return !!pathOr(null, ['data', 'contractEnd'], offeringDisconnect);
});